import { useState } from 'react';
import { useAuth } from '../component/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, Divider, message, Space } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined, UserAddOutlined } from '@ant-design/icons';

const { Title } = Typography;

const AuthPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (values: { customerId: string; password: string }) => {
    const { customerId, password } = values;
    setLoading(true);
    
    try {
      const success = await login(customerId, password);
      if (success) {
        message.success('Login successful!');
        navigate('/');
      }
    } catch (error: any) {
      message.error(error.message || 'An error occurred during login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '40px auto' }}>
      <Card
        bordered={false}
        style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}
      >
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <Title level={3}>Welcome Back</Title>
          <Typography.Paragraph type="secondary">
            Please sign in to continue
          </Typography.Paragraph>
        </div>
        
        <Form
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={handleLogin}
          autoComplete="off"
        >
          <Form.Item
            name="customerId"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input 
              prefix={<UserOutlined style={{ color: '#bfbfbf' }} />} 
              placeholder="Username" 
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="Password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              icon={<LoginOutlined />}
              size="large"
              block
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
        
        <Divider>
          <Typography.Text type="secondary">
            New here?
          </Typography.Text>
        </Divider>
        
        <Button
          type="default"
          icon={<UserAddOutlined />}
          size="large"
          block
          onClick={() => navigate("/sign-up")}
        >
          Create Account
        </Button>
      </Card>
    </div>
  );
};

export default AuthPage;